import * as api from "../Api";
import {loginRequestFailed, loginRequestStarted, loginRequestSuccess, logoutUser} from "./AuthViewActions";
import history from "../../history/History";
import ConsoleHelper from "../../helpers/ConsoleHelper";

export const loginUser = (data) => {
    return (dispatch) => {
        dispatch(loginRequestStarted())
        api.loginUser(data)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(loginRequestSuccess(resp.data.data))
                    history.push("/");
                } else {
                    dispatch(loginRequestFailed(resp.data.message))
                }
            }).catch(error => {
                ConsoleHelper(error.message);
            // dispatch(loginRequestFailed(error.message))
        })
    }
}


export const refreshToken = (refreshToken) => {
    return (dispatch) => {
        dispatch(loginRequestStarted())
        api.refreshToken(refreshToken)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(loginRequestSuccess(resp.data.data))
                }
            })
    }
}

export const logoutUserFromServer = () => {
    return (dispatch) => {
        api.logoutUserFromServer()
            .then(() => {
                dispatch(logoutUser())
                history.push("/login")
            })
            .catch(() => {
                dispatch(logoutUser())
                history.push("/login")
            })
    }
}

